(function () {
  var usp = document.querySelector('[id$="__trust-icons"]');
  if (usp) {
    var row = usp.querySelector('.text-with-icons__blocks');
    if (row) {
      row.querySelectorAll('.text-with-icons__block[aria-hidden="true"]').forEach(function (clone) {
        clone.remove();
      });
      row.classList.remove('homepage-usp-track');
      delete row.dataset.uspCloned;
    }

  }

  var countHolders = document.querySelectorAll('[data-homepage-wwk-count]');
  if (countHolders.length) {
    var applyReviewCount = function (amount) {
      var rounded = Math.floor(Number(amount) / 100) * 100;
      if (!rounded) return;
      var formatted = rounded.toLocaleString('nl-NL');
      countHolders.forEach(function (countHolder) {
        var template = countHolder.getAttribute('data-count-template') || 'Uit __COUNT__+ reviews';
        var target = countHolder.querySelector('p') || countHolder;
        target.textContent = template.replace('__COUNT__', formatted);
      });
    };

    var readCachedAmount = function () {
      var footer = document.querySelector('[data-footer-reviews]');
      var shopId = footer && footer.getAttribute('data-shop-id');
      if (shopId) {
        try {
          var cached = JSON.parse(window.localStorage.getItem('xinzuo-wwk-reviews-hist-v3-' + shopId));
          if (cached && cached.amount) return cached.amount;
        } catch (err) {}
      }
      if (footer) {
        var fallback = Number(footer.getAttribute('data-review-count'));
        if (fallback) return fallback;
      }
      return 0;
    };

    var initialAmount = readCachedAmount();
    if (initialAmount) applyReviewCount(initialAmount);

    document.addEventListener('wwk:reviews', function (event) {
      if (event.detail && event.detail.amount) {
        applyReviewCount(event.detail.amount);
      }
    });
  }

  var syncHomepageUspOffset = function () {
    if (!usp) {
      document.documentElement.style.removeProperty('--homepage-usp-bar');
      document.documentElement.style.removeProperty('--homepage-header-bar');
      return;
    }

    var header = document.querySelector('.site-header');
    if (header) {
      var headerHeight = Math.round(header.getBoundingClientRect().height);
      if (headerHeight > 0) {
        document.documentElement.style.setProperty('--homepage-header-bar', headerHeight + 'px');
      }
    }

    window.requestAnimationFrame(function () {
      var height = Math.ceil(usp.getBoundingClientRect().height);
      if (height > 0) {
        document.documentElement.style.setProperty('--homepage-usp-bar', height + 'px');
      }
    });
  };

  var syncHomepageUspSolid = function () {
    if (!usp) return;
    usp.classList.toggle('is-usp-solid', !!document.querySelector('.site-header--stuck'));
  };

  syncHomepageUspOffset();
  syncHomepageUspSolid();
  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      syncHomepageUspOffset();
      syncHomepageUspSolid();
    }, 350);
  });
  window.addEventListener('resize', function () {
    syncHomepageUspOffset();
    syncHomepageUspSolid();
  });
  window.addEventListener('pageshow', function () {
    syncHomepageUspOffset();
    syncHomepageUspSolid();
  });
  window.addEventListener('scroll', syncHomepageUspSolid, { passive: true });
  document.addEventListener('header:stickyChange', syncHomepageUspSolid);
})();

(function () {
  var root = document.querySelector('[data-homepage-series]');
  if (!root) return;

  var tabs = root.querySelectorAll('[data-series-tab]');
  var panels = root.querySelectorAll('[data-series-panel]');
  if (!tabs.length || !panels.length) return;

  function activate(id) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-series-tab') === id;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-series-panel') === id;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activate(tab.getAttribute('data-series-tab'));
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (!root.contains(event.target)) return;
    var id = event.detail && event.detail.blockId;
    if (id && root.querySelector('[data-series-tab="' + id + '"]')) {
      activate(id);
      return;
    }
    var panel = event.target.closest('[data-series-panel]');
    if (panel) activate(panel.getAttribute('data-series-panel'));
  });
})();

(function () {
  var section = document.querySelector('[id$="__bestsellers-sfeer"]');
  if (!section) return;

  var scroller = section.querySelector('[data-bestsellers-scroller]');
  var prev = section.querySelector('[data-bestsellers-prev]');
  var next = section.querySelector('[data-bestsellers-next]');
  var grid = scroller && scroller.querySelector('.grid');
  var dotsWrap = section.querySelector('[data-bestsellers-dots]');
  if (!scroller || !prev || !next || !grid) return;

  var items = [];
  var index = 0;
  var drag = null;
  var suppressClick = false;
  var desktopMq = window.matchMedia('(min-width: 769px)');

  var refreshItems = function () {
    items = Array.prototype.slice.call(grid.querySelectorAll('.grid__item.grid-product'));
  };

  var isDesktop = function () {
    return desktopMq.matches;
  };

  var setArrowState = function (button, disabled) {
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  };

  var updateArrows = function () {
    setArrowState(prev, index <= 0);
    setArrowState(next, index >= items.length - 1);
  };

  var restPose = function (offset) {
    var abs = Math.abs(offset);
    var dir = offset < 0 ? -1 : 1;

    if (isDesktop()) {
      if (offset === 0) return { x: 0, scale: 1, rotate: 0, opacity: 1, z: 40 };
      if (abs === 1) return { x: dir * 18, scale: 0.93, rotate: dir * 6, opacity: 1, z: 30 };
      if (abs === 2) return { x: dir * 32, scale: 0.88, rotate: dir * 10, opacity: 1, z: 20 };
      if (abs === 3) return { x: dir * 44, scale: 0.83, rotate: dir * 13, opacity: 1, z: 12 };
      if (abs === 4) return { x: dir * 54, scale: 0.78, rotate: dir * 16, opacity: 0.94, z: 6 };
      return { x: dir * 60, scale: 0.74, rotate: dir * 17, opacity: 0, z: 0 };
    }

    if (offset === 0) return { x: 0, scale: 1, rotate: 0, opacity: 1, z: 40 };
    if (abs === 1) return { x: dir * 18, scale: 0.9, rotate: 0, opacity: 0.92, z: 20 };
    if (abs === 2) return { x: dir * 24, scale: 0.84, rotate: 0, opacity: 0, z: 8 };
    return { x: dir * 18, scale: 0.82, rotate: 0, opacity: 0, z: 0 };
  };

  var lerp = function (from, to, amount) {
    return from + (to - from) * amount;
  };

  var applyStack = function (dragX) {
    var dx = dragX || 0;
    var width = Math.max(1, scroller.clientWidth);
    var cardWidth = (items[index] && items[index].offsetWidth) || width;
    var amount = Math.max(0, Math.min(1, Math.abs(dx) / (cardWidth * 0.5)));
    var incoming = dx < -1 ? 1 : dx > 1 ? -1 : 0;
    var fan = isDesktop();

    items.forEach(function (el, i) {
      var offset = i - index;
      var pose = restPose(offset);
      var x = pose.x;
      var scale = pose.scale;
      var rotate = pose.rotate;
      var opacity = pose.opacity;
      var z = pose.z;

      if (dx !== 0 && offset === 0) {
        x = (dx / cardWidth) * (fan ? 70 : 100);
        scale = lerp(1, 0.96, amount);
        rotate = lerp(0, dx < 0 ? -8 : 8, amount);
        opacity = lerp(1, 0.9, amount);
        z = 50;
      } else if (incoming !== 0 && offset === incoming) {
        var front = restPose(0);
        x = lerp(pose.x, front.x, amount);
        scale = lerp(pose.scale, front.scale, amount);
        rotate = lerp(pose.rotate, front.rotate, amount);
        opacity = lerp(pose.opacity, front.opacity, amount);
        z = 30 + Math.round(12 * amount);
      } else if (incoming !== 0 && offset === incoming * 2) {
        var peek = restPose(incoming);
        x = lerp(pose.x, peek.x, amount);
        scale = lerp(pose.scale, peek.scale, amount);
        rotate = lerp(pose.rotate, peek.rotate, amount);
        opacity = lerp(pose.opacity, peek.opacity, amount);
      } else if (incoming !== 0 && offset === -incoming) {
        x = pose.x + incoming * (fan ? -18 : -12) * amount;
        rotate = pose.rotate + incoming * (fan ? -6 : 0) * amount;
        opacity = pose.opacity * (1 - amount * 0.65);
      }

      el.style.transform = 'translateX(' + x + '%) scale(' + scale + ') rotate(' + rotate + 'deg)';
      el.style.opacity = String(opacity);
      el.style.zIndex = String(z);
      el.style.pointerEvents = opacity > 0.2 && Math.abs(offset) <= (fan ? 4 : 1) ? 'auto' : 'none';
    });
  };

  var syncDots = function () {
    if (!dotsWrap) return;
    if (isDesktop() || items.length < 2) {
      dotsWrap.hidden = true;
      return;
    }
    dotsWrap.hidden = false;
    if (dotsWrap.childElementCount !== items.length) {
      dotsWrap.innerHTML = items.map(function (_el, i) {
        return '<button type="button" aria-label="Bestsellers ' + (i + 1) + ' van ' + items.length + '"></button>';
      }).join('');
    }
    Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  };

  var goTo = function (nextIndex, dragX) {
    if (!items.length) return;
    index = Math.max(0, Math.min(items.length - 1, nextIndex));
    applyStack(dragX || 0);
    syncDots();
    updateArrows();
  };

  var stopDragListeners = function () {
    document.removeEventListener('pointermove', onPointerMove);
    document.removeEventListener('pointerup', onPointerUp);
    document.removeEventListener('pointercancel', onPointerUp);
  };

  var onPointerDown = function (event) {
    if (isDesktop() || (event.pointerType === 'mouse' && event.button !== 0)) return;
    if (drag) stopDragListeners();
    drag = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      dx: 0,
      axis: null
    };
    suppressClick = false;
    document.addEventListener('pointermove', onPointerMove, { passive: false });
    document.addEventListener('pointerup', onPointerUp);
    document.addEventListener('pointercancel', onPointerUp);
  };

  var onPointerMove = function (event) {
    if (!drag || event.pointerId !== drag.id || isDesktop()) return;
    var dx = event.clientX - drag.x;
    var dy = event.clientY - drag.y;
    if (!drag.axis) {
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);
      if (absX < 8 && absY < 8) return;
      drag.axis = absX > absY ? 'x' : 'y';
      if (drag.axis === 'y') {
        drag = null;
        stopDragListeners();
        scroller.classList.remove('is-dragging');
        return;
      }
      scroller.classList.add('is-dragging');
    }
    if (event.cancelable) event.preventDefault();
    var atStart = index === 0 && dx > 0;
    var atEnd = index === items.length - 1 && dx < 0;
    drag.dx = (atStart || atEnd) ? dx * 0.32 : dx;
    applyStack(drag.dx);
  };

  var onPointerUp = function (event) {
    if (!drag || event.pointerId !== drag.id) return;
    var dx = drag.dx;
    var wasHorizontal = drag.axis === 'x';
    drag = null;
    stopDragListeners();
    scroller.classList.remove('is-dragging');
    if (!wasHorizontal) return;
    suppressClick = Math.abs(dx) > 8;
    var threshold = Math.max(40, scroller.clientWidth * 0.12);
    if (dx <= -threshold) goTo(index + 1);
    else if (dx >= threshold) goTo(index - 1);
    else goTo(index);
    window.setTimeout(function () { suppressClick = false; }, 80);
  };

  scroller.addEventListener('pointerdown', onPointerDown);

  scroller.addEventListener('click', function (event) {
    if (suppressClick) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    var item = event.target.closest('.grid__item.grid-product');
    if (!item || !grid.contains(item)) return;
    var itemIndex = items.indexOf(item);
    if (itemIndex > -1 && itemIndex !== index) {
      event.preventDefault();
      event.stopPropagation();
      goTo(itemIndex);
    }
  }, true);

  if (dotsWrap) {
    dotsWrap.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button || !dotsWrap.contains(button)) return;
      goTo(Array.prototype.indexOf.call(dotsWrap.children, button));
    });
  }

  prev.addEventListener('click', function () {
    goTo(index - 1);
  });
  next.addEventListener('click', function () {
    goTo(index + 1);
  });

  var isBlockInView = function () {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    return rect.bottom > 80 && rect.top < vh - 80;
  };

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    var target = event.target;
    if (target) {
      var tag = target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable) return;
    }
    if (!items.length || !isBlockInView()) return;
    var nextIndex = event.key === 'ArrowLeft' ? index - 1 : index + 1;
    if (nextIndex === index || nextIndex < 0 || nextIndex >= items.length) return;
    event.preventDefault();
    goTo(nextIndex);
  });

  var layout = function () {
    refreshItems();
    scroller.scrollLeft = 0;
    goTo(index);
    scroller.classList.add('is-ready');
  };

  var sortCards = function (reviewMap) {
    if (scroller.hasAttribute('data-bestsellers-manual')) return;
    refreshItems();
    if (items.length < 2) return;

    var stats = items.map(function (el, itemIndex) {
      var id = String(el.getAttribute('data-product-id') || '');
      var reviews = parseInt(el.getAttribute('data-bestsellers-reviews') || '0', 10) || 0;
      if (reviewMap && reviewMap[id] && reviewMap[id].count) {
        reviews = Math.max(reviews, Number(reviewMap[id].count) || 0);
      }
      var views = parseInt(el.getAttribute('data-bestsellers-views') || '0', 10) || 0;
      return { el: el, reviews: reviews, views: views, index: itemIndex };
    });

    var maxReviews = 0;
    var maxViews = 0;
    stats.forEach(function (item) {
      if (item.reviews > maxReviews) maxReviews = item.reviews;
      if (item.views > maxViews) maxViews = item.views;
    });
    if (maxReviews < 1) maxReviews = 1;
    if (maxViews < 1) maxViews = 1;

    stats.forEach(function (item) {
      item.score = (item.reviews / maxReviews) * 0.5 + (item.views / maxViews) * 0.5;
      item.kind = item.el.getAttribute('data-bestsellers-kind') || 'knife';
      item.series = item.el.getAttribute('data-bestsellers-series') || item.el.getAttribute('data-product-handle') || '';
    });

    stats.sort(function (a, b) {
      if (b.score !== a.score) return b.score - a.score;
      return a.index - b.index;
    });

    var sets = stats.filter(function (item) { return item.kind === 'set'; });
    var knives = stats.filter(function (item) { return item.kind !== 'set'; });
    var used = {};
    var ordered = [];
    var lastSeries = [];
    var wantSet = true;

    var takeFrom = function (pool, checkWindow) {
      var i;
      for (i = 0; i < pool.length; i++) {
        var item = pool[i];
        if (used[item.index]) continue;
        if (checkWindow && lastSeries.indexOf(item.series) !== -1) continue;
        used[item.index] = true;
        return item;
      }
      return null;
    };

    while (ordered.length < stats.length) {
      var pick = takeFrom(wantSet ? sets : knives, true)
        || takeFrom(wantSet ? knives : sets, true)
        || takeFrom(wantSet ? sets : knives, false)
        || takeFrom(wantSet ? knives : sets, false);
      if (!pick) break;
      ordered.push(pick);
      lastSeries.push(pick.series);
      if (lastSeries.length > 2) lastSeries.shift();
      wantSet = !wantSet;
    }

    var changed = ordered.some(function (item, itemIndex) {
      return item.el !== items[itemIndex];
    });
    if (!changed) return;

    ordered.forEach(function (item) {
      grid.appendChild(item.el);
    });
    scroller.scrollLeft = 0;
    index = 0;
    layout();
  };

  var readCachedReviews = function () {
    try {
      var cached = JSON.parse(window.localStorage.getItem('xinzuo-wwk-product-reviews-v1'));
      if (cached && cached.products) return cached.products;
    } catch (err) {}
    return null;
  };

  layout();
  window.addEventListener('resize', layout);
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', layout);
  else if (desktopMq.addListener) desktopMq.addListener(layout);
  sortCards(readCachedReviews());
  document.addEventListener('wwk:product-reviews', function (event) {
    sortCards(event.detail || null);
  });
})();

(function () {
  var section = document.querySelector('[id$="__hero"]');
  if (!section) return;

  var slide = section.querySelector('.slideshow__slide.is-selected') || section.querySelector('.slideshow__slide');
  var title = slide && slide.querySelector('.hero__title');
  var target = title && title.querySelector('.animation-contents');
  if (!title || !target) return;

  var showTitle = function (html) {
    title.classList.remove('is-hero-typing');
    title.classList.add('is-hero-typed');
    if (typeof html === 'string') target.innerHTML = html;
  };

  try {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animationsOff = document.documentElement.getAttribute('data-disable-animations') === 'true';
    var designMode = window.Shopify && window.Shopify.designMode;

    if (reduceMotion || animationsOff || designMode) {
      showTitle();
      return;
    }

    var sourceHtml = target.innerHTML;
    var lines = sourceHtml
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .split('\n')
      .map(function (line) {
        return line.replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);

    if (!lines.length) {
      showTitle();
      return;
    }

    var html = '';
    var lineIndex = 0;
    var charIndex = 0;
    var finished = false;
    var CHAR_MS = 24;
    var LINE_MS = 280;
    var START_MS = 980;
    var wait = null;

    title.setAttribute('aria-label', lines.join(' '));
    target.setAttribute('aria-hidden', 'true');

    var finish = function () {
      if (finished) return;
      finished = true;
      if (wait) window.clearInterval(wait);
      showTitle(lines.join('<br>'));
    };

    var tick = function () {
      if (finished) return;

      if (lineIndex >= lines.length) {
        window.setTimeout(finish, 280);
        return;
      }

      var line = lines[lineIndex];
      if (charIndex === 0 && lineIndex > 0) {
        html += '<br>';
      }

      if (charIndex < line.length) {
        html += line.charAt(charIndex);
        charIndex += 1;
        target.innerHTML = html;
        window.setTimeout(tick, CHAR_MS);
        return;
      }

      lineIndex += 1;
      charIndex = 0;
      target.innerHTML = html;
      window.setTimeout(tick, LINE_MS);
    };

    var start = function () {
      if (finished || title.classList.contains('is-hero-typing')) return;
      target.innerHTML = '';
      title.classList.add('is-hero-typing');
      tick();
    };

    var hero = section.querySelector('.hero') || section;
    var started = false;
    var begin = function () {
      if (started) return;
      started = true;
      if (wait) window.clearInterval(wait);
      window.setTimeout(start, START_MS);
    };

    if (hero.classList.contains('loaded')) {
      begin();
    } else {
      var tries = 0;
      wait = window.setInterval(function () {
        tries += 1;
        if (hero.classList.contains('loaded') || tries >= 20) {
          begin();
        }
      }, 80);
    }

    window.setTimeout(function () {
      if (!finished && !title.classList.contains('is-hero-typing')) finish();
    }, 3800);

    window.setTimeout(function () {
      if (!finished) finish();
    }, 7000);
  } catch (err) {
    showTitle();
  }
})();

(function () {
  var root = document.querySelector('[data-homepage-reviews]');
  if (!root) return;

  var scoreEl = root.querySelector('[data-homepage-reviews-average]');
  var countEl = root.querySelector('[data-homepage-reviews-count]');
  if (!scoreEl && !countEl) return;

  var apply = function (average, amount) {
    var scale10 = Number(average);
    if (scale10 && scale10 <= 5) scale10 = scale10 * 2;
    if (scoreEl && scale10) {
      scoreEl.textContent = scale10.toFixed(1).replace('.', ',') + ' / 10';
    }
    if (countEl && amount) {
      var rounded = Math.floor(Number(amount) / 100) * 100;
      if (!rounded) rounded = Number(amount);
      var template = countEl.getAttribute('data-count-template') || 'Gebaseerd op __COUNT__+ beoordelingen via WebwinkelKeur';
      countEl.textContent = template.replace('__COUNT__', rounded.toLocaleString('nl-NL'));
    }
  };

  var readCached = function () {
    var footer = document.querySelector('[data-footer-reviews]');
    var shopId = footer && footer.getAttribute('data-shop-id');
    if (shopId) {
      try {
        var cached = JSON.parse(window.localStorage.getItem('xinzuo-wwk-reviews-hist-v3-' + shopId));
        if (cached) return cached;
      } catch (err) {}
    }
    if (footer) {
      return { amount: Number(footer.getAttribute('data-review-count')) || 0, average: 0 };
    }
    return null;
  };

  var cached = readCached();
  if (cached) apply(cached.average, cached.amount);

  document.addEventListener('wwk:reviews', function (event) {
    if (!event.detail) return;
    apply(event.detail.average, event.detail.amount);
  });
})();
